export default {"src":"/_next/static/media/yoga.a3781b30.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};